import { language as lan_registForm } from "./regist-form";
import { language as lan_thirdPartyRegist } from "./third-party-regist";

let language = {
    ...lan_thirdPartyRegist,
    ...lan_registForm,

    REGIST_CREATE_ACCOUNT_TEXT: "创建您的免费账户，立即开始销售",
    REGIST_SIGNUP_WITH_EMAIL_BTN: "使用您的电子邮箱注册",
    REGIST_BACK_BTN: "返回",
    REGIST_ALREADY_HAVE_ACCOUNT_TEXT: "已有账户?",
    REGIST_SIGNIN_LINK: "登录",
    REGIST_OTHER_REGISTRATION_TEXT: "Others Registration",

    "A114B001": "请输入8至20个字符，包括大写字母、小写字母、数字和符号",
    "A114B002": "您的“确认密码”应该与您的密码相同",
};

export { language }